import axios from 'axios'

axios.interceptors.response.use(
  res => {
    return Promise.resolve({data: res.data})
  },
  error => {
    return Promise.resolve({error: error.response})
  }
)

export default {
  async getLive(url) {
    // console.log(`YouTube.getLive(): url = ${url}`)
    let { data, error } = await axios.post(`/api/youtube-live`, {
      url: url
    })

    if (error) {
      return { data: undefined, error: error }
    }

    return { data: data, error: undefined }
  },
  async getLiveChat(live, timestamp) {
    // console.log(`YouTube.getLiveChat(): `, live, timestamp)

    let url = `/api/youtube-livechat`

    let { data, error } = await axios.post(url, live)
    if (error) {
      return false
    }

    let continuation = getContinuation(data)

    let actions = data.continuationContents.liveChatContinuation.actions

    if (! actions) {
      return {
        continuation: live.continuation,
        timestamp: timestamp,
        comments: [],
      }
    }

    let comments = actions
      .filter(a => {
        return !! a.addChatItemAction
            && a.addChatItemAction.item.liveChatTextMessageRenderer
      })
      .map(a => {
        let renderer = a.addChatItemAction.item.liveChatTextMessageRenderer

        let timestamp = renderer && renderer.timestampUsec
        let author = renderer && renderer.authorName.simpleText
        let message = renderer && renderer.message.runs.map(r => r.text).join('')

        // console.log(JSON.stringify(renderer.message.runs))
        // console.log(`author = ${author}`)
        // console.log(`message = ${message}`)
        // console.log(`${author}: ${message}`)
        return {timestamp, author, message}
      })
      .filter(it => !!it.author && !!it.message)
      .filter(it => timestamp < it.timestamp)
    
    return {
      continuation: continuation,
      timestamp: comments.length == 0 ? timestamp : comments[comments.length - 1].timestamp,
      comments: comments,
    }
  }
}

function getContinuation(data) {
  let nextContinuation = data.continuationContents.liveChatContinuation.continuations[0]
  let personalChannelContinuation = (nextContinuation.invalidationContinuationData ?? {}).continuation
  let officialChannelContinuation = (nextContinuation.timedContinuationData ?? {}).continuation
  let continuation = personalChannelContinuation || officialChannelContinuation
  return continuation
}